import { render, staticRenderFns } from "./organisationGroup.vue?vue&type=template&id=acbc6a66&scoped=true&"
import script from "./organisationGroup.vue?vue&type=script&lang=js&"
export * from "./organisationGroup.vue?vue&type=script&lang=js&"
import style0 from "./organisationGroup.vue?vue&type=style&index=0&id=acbc6a66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbc6a66",
  null
  
)

export default component.exports